import styles from './styles.module.scss';
import cn from 'classnames';
import { InlineSvg } from 'components/svg';
import { ToggleState } from 'hooks/use-toggle';
import { FC, useEffect, useRef, useState } from 'react';
import Flatpickr from 'react-flatpickr';
import { formatDate } from 'utils/formats';

interface IProps {
  state: ToggleState<number>;
  onDateSelected: (index: number, date: string) => void;
}

const SelectDateModal: FC<IProps> = ({ state, onDateSelected }) => {
  const [selectedDate, setSelectedDate] = useState<Date | null>(null);

  useEffect(() => {
    document.body.classList.add('modal-open');
    return () => {
      document.body.classList.remove('modal-open');
    };
  }, []);

  const refStartDate = useRef<Flatpickr>(null);

  const cancel = () => {
    state.close();
  };

  const handleSubmit = () => {
    const index = state?.data ?? -1;

    if (selectedDate && index > -1) {
      const formattedDate = formatDate(selectedDate, 'YYYY-MM-DD');
      onDateSelected(index, formattedDate);
      state.close();
    }
  };

  return (
    <>
      <div
        className="modal fade show d-block"
        id="kt_modal_add_configuration"
        role="dialog"
        tabIndex={-1}
        aria-modal="true"
      >
        {/* begin::Modal dialog */}
        <div className={cn('modal-dialog modal-dialog-centered modal-md', styles.modal)}>
          {/* begin::Modal content */}
          <div className="modal-content">
            <div className="modal-header py-4 d-flex align-items-center">
              <h2 className="fw-bolder mb-0">Please select reminder date</h2>
              <div
                className="btn btn-icon btn-sm btn-active-icon-primary"
                data-kt-employees-modal-action="close"
                onClick={() => cancel()}
                style={{ cursor: 'pointer' }}
              >
                <InlineSvg path="/media/icons/duotune/arrows/arr061.svg" className="svg-icon-1" />
              </div>
            </div>
            {/* begin::Modal body */}
            <div className="modal-body mx-2 pt-0">
              <div className="row">
                <div className="col-12 mt-4">
                  <div className={styles.calendarContainer}>
                    <Flatpickr
                      ref={refStartDate}
                      className={cn(styles.dateInput)}
                      onChange={([date]) => {
                        setSelectedDate(date);
                      }}
                      options={{
                        dateFormat: 'd/m/Y',
                        static: true,
                        inline: true,
                        minDate: 'today',
                        clickOpens: false,
                        locale: {
                          firstDayOfWeek: 1
                        }
                      }}
                    />
                  </div>
                </div>
              </div>

              <div className="row">
                <div className="col-12 mb-2">
                  <div className="d-flex justify-content-left mt-7">
                    <button className="btn btn-primary me-5" disabled={!selectedDate} onClick={handleSubmit}>
                      Submit
                    </button>
                    <button
                      onClick={() => {
                        state.close();
                      }}
                      className="btn btn-light-primary me-5"
                    >
                      Cancel
                    </button>
                  </div>
                </div>
              </div>
            </div>
            {/* end::Modal body */}
          </div>
          {/* end::Modal content */}
        </div>
        {/* end::Modal dialog */}
      </div>
      {/* begin::Modal Backdrop */}
      <div className="modal-backdrop fade show"></div>
      {/* end::Modal Backdrop */}
    </>
  );
};

export default SelectDateModal;
